import ImageGrid from '../../../UI/ImageGrid/ImageGrid';
import Button from '../../../UI/Button/Button';
import heroBannerImage from '../../../../assets/HomePage/HeroBannerImg.png';
import './HeroBanner.css';

import { Grid, Typography, Link } from '@mui/material';
import { createPopup } from '@typeform/embed';
import '@typeform/embed/build/css/popup.css';

const { toggle } = createPopup('qXnRr9dp');

const HeroBanner = (props) => {
  return (
    <Grid container spacing={6} alignItems='center' sx={{ mt: '1.5rem' }}>
      <Grid item lg={8}>
        <Typography variant='h3' component='h1' sx={{ fontWeight: 'bold', fontSize: '3' }}>
          We're a{' '}
          <Typography variant='h3' component='span' sx={{ color: 'secondary.main', fontWeight: 'bold' }}>
            Mastermind Community
          </Typography>{' '}
          for<br></br>
          {
            <Typography variant='h1' component='span' sx={{ fontWeight: 'bold' }}>
              100
            </Typography>
          }{' '}
          SaaS Founders
        </Typography>
        <Typography variant='body1' sx={{ my: '2rem' }}>
          Learn from the accumulated knowledge of 100 entrepreneurs facing the same evolving challenges as you. We are a
          private peer-advisory community focussed on connecting and supporting you with 100 SaaS Founders.
        </Typography>
        <Link
          key={1}
          onClick={toggle}
          sx={{
            textDecoration: 'none',
          }}>
          <Button text='Join the Waitlist (Limited Slots)' symbol='arrow' />
        </Link>
      </Grid>
      <ImageGrid gridSize={4} src={heroBannerImage} alt={'Hero Banner'} maxWidth={{ maxWidth: '400px' }} />
    </Grid>
  );
};

export default HeroBanner;
